{"ellipsis":"...","signIn":"Sign in","signOut":"Sign out"}